<script>
  import { Badge } from "../main";
</script>

<Badge on:click={() => alert('clicked')}>I'm clickable</Badge>
